import React from 'react';

import { ShadedBox, ShadedBoxTitle } from '../BasePage';
import { IUEvent } from '../../lib/event';

import PhotosLink from './PhotosLink';
import styled from 'styled-components';

const AlbumDetails = ({ event, setShowPhotoViewer }: {
  event: IUEvent,
  setShowPhotoViewer: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const albumDetails = event.albumDetails;

  if (albumDetails === undefined) {
    return null;
  }

  const albumPreviewUrl = albumDetails.animatedPreviewUrl;

  return <ShadedBox>
    <ShadedBoxTitle>Photos {(albumDetails?.photoCount ?? 0) > 0 ? `(${albumDetails.photoCount})` : null}</ShadedBoxTitle>
    <PhotosLink event={event}/>

    {albumDetails.photoMetas !== undefined && albumDetails.photoMetas.length > 0 &&
      <>
        <PreviewContainer onClick={() => setShowPhotoViewer(true)}>
          {albumPreviewUrl !== undefined
            ? <PreviewVideo autoPlay muted loop playsInline>
              <source src={albumPreviewUrl} type="video/mp4"/>
              Your browser does not support the video tag.
            </PreviewVideo>
            : albumDetails.photoMetas.map((photoMeta, index) => {
              if (index === 3) {
                return <ExtraImageCount
                  key={photoMeta.photoId}>+{(albumDetails?.photoCount ?? 0) - index}</ExtraImageCount>
              } else if (index < 3) {
                return <PreviewImage key={photoMeta.photoId} src={photoMeta.thumbnailUrl}/>
              } else {
                return null
              }
            })}
        </PreviewContainer>
        <SeePhotosText onClick={() => setShowPhotoViewer(true)}>
          See all photos
        </SeePhotosText>
      </>}
  </ShadedBox>;
};

const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 100px;
  margin: 2px;
  border-radius: 6px;
  cursor: pointer;
`;

const PreviewVideo = styled.video`
  max-width: 100%;
  max-height: 200px;
  cursor: pointer;
`

const ExtraImageCount = styled.div`
  height: 100px;
  width: 100px;
  background-color: #000;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
`

const SeePhotosText = styled.div`
  width: 100%;
  text-align: right;
  margin: 2px 0;
  font-size: 14px;
  cursor: pointer;
`

export default AlbumDetails;
